// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_36LERFGp","large":"large_1jp3b-db","xsmall":"xsmall_3oK7uCL7","inline":"inline_1QBgO4DX","center":"center_2biNu1sU"};